import { isMongoObjectId } from "./phone";

const sanitizeProductLinksForApi = (links = []) =>
  links.map(({ _id, url, store }) => {
    const entry = {
      url: url ?? "",
    };

    if (store) {
      entry.store = store;
    }

    if (isMongoObjectId(_id)) {
      entry._id = _id;
    }

    return entry;
  });

/** Strip client UUIDs before PATCH; keep only valid MongoDB _id values. */
export const sanitizeProductsForApi = (products = []) =>
  products.map(({ _id, title, price, pictures, links }) => {
    const entry = {
      title: title ?? {},
      price: price ?? { amount: 0, currency: "MAD" },
      pictures: pictures ?? [],
      links: sanitizeProductLinksForApi(links),
    };

    if (isMongoObjectId(_id)) {
      entry._id = _id;
    }

    return entry;
  });
